// src/components/common/LockedInfoBanner.jsx
import React from "react";
import StatusBanner from "./StatusBanner";

function LockedInfoBanner({ locked = false }) {
    if (locked) {
        return (
            <StatusBanner variant="danger">
                GROTE BOEK VOOR DIT BEZOEK STAAT DICHT! INFORMATIE KAN NIET GEWIJZIGD WORDEN DOOR KLANTEN!
            </StatusBanner>
        );
    }
    return (
        <StatusBanner variant="danger">
            LOCK NIET ACTIEF INFORMATIE KAN DOOR KLANTEN GEWIJZIGD WORDEN!
        </StatusBanner>
    );
}

export default LockedInfoBanner;